import { useHistory } from "react-router-dom";
import { Button } from "@panviva/panviva-react-ui";
import { useSelector } from "react-redux";
import errorImage from "../../assets/images/error-404.png";
import { RootState } from "../../app/store";
import "./NotFoundPage.scss";

export const NotFoundPage: React.FC = () => {
    const history = useHistory();
    const loading = useSelector((state: RootState) => state?.users?.loading);

    // Wait for any in-flight requests to settle before rendering the 404 content,
    // so the global loading spinner doesn't overlay the not-found page.
    if (loading) {
        return null;
    }

    return (
        <div className="not-found-page">
            <img src={errorImage} alt="Not Found" />
            <p>The page or resource was not found.</p>
            <Button variant="contained" onClick={() => history.push('/')} style={{ marginTop: '1rem' }}>
                Go to Home
            </Button>
        </div >
    );
}